module.exports = __webpack_public_path__ + "media/signup-react/watch-6b7e26b9.png";